import { cn } from '@/lib/utilitarios'

export type Aba = 'inicio' | 'diario' | 'comunidade' | 'biblioteca' | 'evolucao' | 'perfil'

const ABAS: { id: Aba; rotulo: string; emoji: string }[] = [
  { id: 'inicio', rotulo: 'Hoje', emoji: '🌺' },
  { id: 'diario', rotulo: 'Diário', emoji: '📔' },
  { id: 'comunidade', rotulo: 'Comunidade', emoji: '💬' },
  { id: 'biblioteca', rotulo: 'Biblioteca', emoji: '📚' },
  { id: 'evolucao', rotulo: 'Evolução', emoji: '📈' },
  { id: 'perfil', rotulo: 'Perfil', emoji: '👤' },
]

/**
 * Navegação fixa no rodapé.
 *
 * Rodapé e não topo: o app é usado com uma mão, e o alcance do polegar
 * na metade de baixo da tela é o que torna o check-in diário rápido o
 * bastante para virar hábito.
 */
export function BarraNavegacao({
  ativa,
  aoTrocar,
}: {
  ativa: Aba
  aoTrocar: (aba: Aba) => void
}) {
  return (
    <nav
      aria-label="Navegação principal"
      className="fixed inset-x-0 bottom-0 z-50 mx-auto max-w-md border-t border-[var(--borda)] bg-[var(--cartao)]/95 backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="flex">
        {ABAS.map((item) => {
          const selecionada = ativa === item.id
          return (
            <li key={item.id} className="flex-1">
              <button
                type="button"
                onClick={() => aoTrocar(item.id)}
                aria-current={selecionada ? 'page' : undefined}
                className={cn(
                  'flex w-full flex-col items-center gap-0.5 py-2.5 transition-colors',
                  selecionada ? 'text-coral' : 'text-[var(--tinta-apagada)]',
                )}
              >
                <span
                  className={cn('text-xl transition-transform', selecionada && 'scale-115')}
                  aria-hidden
                >
                  {item.emoji}
                </span>
                <span className="text-[11px] font-medium">{item.rotulo}</span>
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
